import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AccountAuthorization, IAPIAccountAuthorization } from 'src/model/accountAuthorization';

@Injectable({
  providedIn: 'root'
})
export class AccountAuthorzationAdapter {

  adapt(item: any): AccountAuthorization {
    return new AccountAuthorization(
      item.id,
      item.remark,
      item.granted_until,
      item.granted_remark,
      item.created_at,
      item.created_by,
      item.granted_by,
      item.customer_account_id,
      item.customerName,
      item.icNumber,
      item.revoked_remark,
      item.revoked_by,
      item.revoked_on

    )
  }

  toApiModel(authorization: AccountAuthorization): IAPIAccountAuthorization {

    return {
      ...(authorization.ID && { id: authorization.ID }),
      remark: authorization.Remark,
      ...(authorization.GrantedUntil && { granted_until: authorization.GrantedUntil }),
      ...(authorization.GrantedRemark && { granted_remark: authorization.GrantedRemark }),
      ...(authorization.RevokedRemark && { revoked_remark: authorization.RevokedRemark }),

    }

  }
}

@Injectable({
  providedIn: 'root'
})
export class AccountAuthorizationService {
  private api = inject(RestApiService);
  private constructAPI = inject(ConstructAPI);
  private adapter = inject(AccountAuthorzationAdapter);

  getAddAccountAuthrozation(customerId: number, accountId: number, authorization: AccountAuthorization) {
    return new Promise<AccountAuthorization>((resolve, reject) => {
      this.api.post<AccountAuthorization>(this.constructAPI.getAddAccountAuthorization(customerId, accountId), this.adapter.toApiModel(authorization)).subscribe({
        next: response => {
          resolve(this.adapter.adapt(response));
        },
        error: err => {
          this.api.handleError(err);
          console.error('Failed to add account authorization: ', err);
          reject(err);
        }
      })
    })
  }

  getAllAccountAuthorizations(customerIds: number[], contactId: number, pending: boolean): Promise<AccountAuthorization[]> {
    return new Promise<AccountAuthorization[]>((resolve, reject) => {
      this.api.get<AccountAuthorization[]>(this.constructAPI.getAllCustomerAccountsAuthorization(customerIds, contactId, pending)).pipe(
        map(data => data.map(d => this.adapter.adapt(d)
        ))
      ).subscribe(
        {
          next: (response) => { resolve(response) },
          error: err => {
            this.api.handleError(err);
            console.error('Failed to geT account authorizations: ', err);
            reject(err);
          }
        }
      )
    })
  }

  getAccountAuthorizations(accountId: number): Promise<AccountAuthorization[]> {
    return new Promise<AccountAuthorization[]>((resolve, reject) => {
      this.api.get<AccountAuthorization[]>(this.constructAPI.getAccountAuthorization(accountId)).pipe(
        map(data => data.map(d => this.adapter.adapt(d)
        ))
      ).subscribe(
        {
          next: (response) => { resolve(response) },
          error: err => {
            this.api.handleError(err);
            console.error('Failed to get customer account: ', err);
            reject(err);
          }
        }
      )
    })
  }

  getAuthorization(id: number): Promise<AccountAuthorization> {
    return new Promise<AccountAuthorization>((resolve, reject) => {
      this.api.get<AccountAuthorization[]>(this.constructAPI.getAccountAuthorizationById(id))
        .subscribe(
          {
            next: (response) => { resolve(this.adapter.adapt(response)) },
            error: err => {
              this.api.handleError(err);
              console.error('Failed to get customer authorization: ', err);
              reject(err);
            }
          }
        )
    })
  }

  grantAuthorization(id: number, authorization: AccountAuthorization) {
    return new Promise<AccountAuthorization>((resolve, reject) => {
      this.api.post<AccountAuthorization>(this.constructAPI.getGrantAccountAuthorization(id), this.adapter.toApiModel(authorization)).subscribe({
        next: response => {
          resolve(this.adapter.adapt(response));
        },
        error: err => {
          this.api.handleError(err);
          console.error('Failed to grant account authorization: ', err);
          reject(err);
        }
      })
    })
  }

  revokeAuthorization(id: number, authorization: AccountAuthorization) {
    return new Promise<AccountAuthorization>((resolve, reject) => {
      this.api.post<AccountAuthorization>(this.constructAPI.getRevokeAccountAuthorization(id), this.adapter.toApiModel(authorization)).subscribe({
        next: response => {
          resolve(this.adapter.adapt(response));
        },
        error: err => {
          this.api.handleError(err);
          console.error('Failed to revoke account authorization: ', err);
          reject(err);
        }
      })
    })
  }

}
